import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function PatientProgress() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/patient/progress?days=7").then(({ data }) => setData(data)).catch((e) => toast.error(formatApiError(e)));
  }, []);
  if (!data) return <div className="text-muted-foreground">Loading…</div>;

  const totalCompleted = data.days.reduce((s, d) => s + d.completed, 0);
  const totalSkipped = data.days.reduce((s, d) => s + d.skipped, 0);
  const totalWater = data.days.reduce((s, d) => s + d.water_ml, 0);

  return (
    <div className="space-y-6" data-testid="patient-progress-page">
      <header>
        <p className="text-xs uppercase tracking-[0.2em] text-primary font-semibold">Progress</p>
        <h1 className="text-3xl font-bold mt-1">Last 7 days</h1>
      </header>

      <div className="grid grid-cols-3 gap-3">
        <div className="nt-stat" data-testid="progress-completed"><span className="nt-label">Completed</span><div className="text-2xl font-bold">{totalCompleted}</div></div>
        <div className="nt-stat" data-testid="progress-skipped"><span className="nt-label">Skipped</span><div className="text-2xl font-bold">{totalSkipped}</div></div>
        <div className="nt-stat" data-testid="progress-water"><span className="nt-label">Water</span><div className="text-2xl font-bold">{(totalWater / 1000).toFixed(1)}L</div></div>
      </div>

      <div className="nt-card p-5">
        <h2 className="font-semibold mb-3">Daily breakdown</h2>
        <div className="space-y-2">
          {data.days.map((d) => (
            <div key={d.date} className="flex items-center gap-3" data-testid={`day-${d.date}`}>
              <div className="text-xs text-muted-foreground w-16">{d.date.slice(5)}</div>
              <div className="flex-1 grid grid-cols-12 gap-1 h-8 items-center">
                <div className="col-span-7 h-2 bg-muted rounded-full overflow-hidden">
                  <div className="h-full bg-primary" style={{ width: `${Math.min(100, (d.completed / 4) * 100)}%` }} />
                </div>
                <span className="col-span-2 text-xs">{d.completed}/4</span>
                <span className="col-span-3 text-xs text-muted-foreground text-right">{d.water_ml}ml</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
